/**
 * Generated by orval v8.14.0 🍺
 * Do not edit manually.
 * Realico Portal API
 * Portal API
 * OpenAPI spec version: 1.0.0
 */

export type GetListingsSortType = typeof GetListingsSortType[keyof typeof GetListingsSortType];


export const GetListingsSortType = {
  asc: 'asc',
  desc: 'desc',
} as const;
